module.exports = __webpack_public_path__ + "img/step1.90aff107.webp";